module.exports = __webpack_public_path__ + "fonts/b4e6ba41/proximanova-boldit-webfont.ttf";